package com.devi3east.bashbuddy.auth.domain.models

import kotlinx.serialization.Serializable

@Serializable
enum class UserType {
    USER,
    ORGANIZATION
}